import CustomSkeleton, { SkeletonStyleProps } from 'react-loading-skeleton';
import { useTheme } from 'styled-components';

import { SkeletonWrapper } from './Skeleton.styled';

type SkeletonVariant = 'default' | 'inverted';

interface SkeletonProps {
    className?: string;
    count?: number;
    height?: number;
    inline?: boolean;
    variant?: SkeletonVariant;
    width?: number | string;
}

export const Skeleton = ({
    className,
    count,
    height = 180,
    inline = false,
    variant = 'default',
    width,
}: SkeletonProps) => {
    const { palette } = useTheme();

    const color: Record<
        SkeletonVariant,
        Pick<SkeletonStyleProps, 'baseColor' | 'highlightColor'>
    > = {
        default: {
            baseColor: palette.tertiary.background,
            highlightColor: palette.neutral.white,
        },
        inverted: {
            baseColor: palette.neutral.white,
            highlightColor: palette.tertiary.background,
        },
    };

    return (
        <SkeletonWrapper className={className} inline={inline}>
            <CustomSkeleton
                {...color[variant]}
                count={count}
                height={height}
                width={width}
            />
        </SkeletonWrapper>
    );
};
